import { observable } from 'mobx';
import { Model } from '../Model';
import { User } from './UserModel';
import { KnowledgeBaseStatus } from '../../enums/KnowledgeBaseStatus';

export class KnowledgeBase extends Model {
  static _store: any;

  @observable id: number;

  @observable title: string;

  @observable description: string;

  @observable thumbnail: string;

  @observable status: KnowledgeBaseStatus;

  @observable url: string;

  @observable uploaded_by: number;

  @observable uploadedBy: User;

  @observable tags: string[];

  @observable created_at: string;

  @observable updated_at: string;

  get isActive(): boolean {
    return this.status === KnowledgeBaseStatus.ACTIVE;
  }

  get hasThumbnail(): boolean {
    return !!this.thumbnail;
  }

  get displayTags(): string[] {
    return this.tags || [];
  }

  get formattedCreatedAt(): string {
    if (!this.created_at) return '';
    return new Date(this.created_at).toLocaleDateString();
  }

  get formattedUpdatedAt(): string {
    if (!this.updated_at) return '';
    return new Date(this.updated_at).toLocaleDateString();
  }
}
